export default "__VITE_ASSET__DdM8BxKz__"